// extracted by mini-css-extract-plugin
export default {"cover":"TemplatePreview_cover__8c6r1","sheet":"TemplatePreview_sheet__IVjE4"};